import { AUTHORIZED, COOWNER, OWNER, REPRESENTATIVE } from 'constants/jointHolders/holderTypes';

export const getIsRepresentative = holdingType => holdingType === REPRESENTATIVE;
export const getIsCoOwner = holdingType => holdingType === COOWNER;
export const getIsOwner = holdingType => holdingType === OWNER;
export const getIsJointHolder = holdingType =>
    holdingType === COOWNER || holdingType === AUTHORIZED || holdingType === REPRESENTATIVE;
export const getIsAuthorized = holdingType => holdingType === AUTHORIZED || holdingType === REPRESENTATIVE;
export const getIsJointHolderAccount = (holdingType, numberOfInvites) => holdingType === OWNER && numberOfInvites > 0;
